import React from 'react';
export const EditLine = () => /*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.4001 7.34L16.6601 4.6C15.9198 3.90465 14.7759 3.87455 14.0001 4.53L5.00006 13.53C4.67682 13.856 4.47556 14.2832 4.43006 14.74L4.00006 18.91L4.00006 18.91C3.97278 19.2065 4.07909 19.4998 4.29006 19.71H4.29006C4.47878 19.8972 4.73425 20.0015 5.00006 20H5.09006L9.26006 19.62C9.71685 19.5745 10.1441 19.3732 10.4701 19.05L19.4701 10.05C20.1973 9.28166 20.166 8.06977 19.4001 7.34L19.4001 7.34ZM9.08006 17.62L6.08006 17.9L6.35006 14.9L12.0001 9.32L14.7001 12.02L9.08006 17.62ZM16.0001 10.68L13.3201 8L15.2701 6L18.0001 8.73L16.0001 10.68Z",
  fill: "currentColor"
}));